export default __webpack_public_path__ + "static/media/15.70a76b41.JPG";